import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import BackBtn from "../images/backButton.svg";

function RedirectModal(props) {
  function close() {
    if (props.hideModal) {
      props.hideModal();
    }
  }

  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={close}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={
                    !props.innerPage
                      ? "w-full max-w-md transform overflow-hidden rounded-md bg-[#171538] p-4 pt-2 text-left align-middle shadow-xl transition-all"
                      : "w-full max-w-md transform overflow-hidden rounded-md bg-[#e8e7ef] p-4 pt-2 text-left align-middle shadow-xl transition-all"
                  }
                >
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>
                  <div className="doc-modal flex-col items-center justify-center mt-2">
                    <div className="flex justify-center items-center"></div>
                    <div className="flex items-center justify-between gap-4">
                      <div>
                        {!props.innerPage ? (
                          <div>
                            <div className="head">No bookings Found.</div>
                            <div className="label text-sm">
                              Currently no bookings found in this booking Id.
                            </div>
                          </div>
                        ) : (
                          <div className="text-sm text-black ml-5">
                            This feature is available only after Checkin
                          </div>
                        )}
                      </div>

                      <Link to={props.innerPage ? "../home" : "../hotel-list"}>
                        <img
                          className={
                            !props.innerPage
                              ? "p-4 rounded-md bg-[#443765]"
                              : "p-4 rounded-md bg-[#534e5e]"
                          }
                          src={BackBtn}
                          alt=""
                        />
                      </Link>
                    </div>
                  </div>

                  <div className="absolute top-2 right-2 "></div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default RedirectModal;
